import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import clsx from "classnames";
import TimeClock from "@/assets/TimeClock.svg";
import Calendar from "@/assets/Calendar.svg";
import { format } from "date-fns";
// import { format } from "date-fns";
// import { trimText } from "@/functions/trimText";

export default function LatestBlogCard({ className, title, category, img, publish_date, minutes, href }) {
  return (
    <a href={href} className={clsx(className, classes.card)}>
      <figure className="ratio ratio-1x1">
        <SourceFlowImage src={img} size="424x170" alt={title} />
      </figure>
      <div className={classes.card__body}>
        <div className={classes.details}>
          <div className={classes.category}>{category}</div>
          {
            minutes ? <div><TimeClock /><span className={classes.desc}>{minutes} Min Read</span></div> : <></>
          }
          {
            !minutes && publish_date ? <div><img src="/icons/calendar.png" alt="calendar" /><span className={classes.desc}>{format(new Date(publish_date.replace(/-/g, "/")), "dd MMM yyyy")}</span></div> : <></>
          }
        </div>
        <div className={classes.title}>{title}</div>
        {/* <time>{format(new Date(published_at), "dd/MM/yyyy")}</time> */}
        {/* <p>{trimText(description, 180)}</p> */}
      </div>
    </a>
  );
}

LatestBlogCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  img: PropTypes.string,
  published_at: PropTypes.string,
};
